import React, { Component, PropTypes } from 'react';
import Icon from './Icon';

export default class AudioHigher extends Icon {
  static defaultProps = {
    color: '#FFFFFF',
    size: 24,
    viewPortSize: 24
  };

  render() {
    let { color, size, style, viewPortSize, className, ...props } = this.props;

    return (
      <svg
        width={size}
        style={style}
        height={size}
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox={'0 0 ' + viewPortSize + ' ' + viewPortSize}
      >
        <g stroke="none" strokeWidth="1" fill="none" fill-rule="evenodd">
          <g transform="translate(-870.000000, -602.000000)" fill={color}>
            <g transform="translate(556.000000, 602.000000)">
              <path d="M334.737314,8.01699916 C335.291302,9.23029424 335.6,10.579097 335.6,12 C335.6,17.3019339 331.301934,21.6 326,21.6 C320.698066,21.6 316.4,17.3019339 316.4,12 C316.4,6.69806614 320.698066,2.4 326,2.4 C328.943687,2.4 331.577923,3.72491397 333.338914,5.81094638 L326.135612,12.6738641 L323.000233,9.53871845 L321.238913,11.3000388 L326.118369,16.1794951 L334.737314,8.01699916 Z M326,24 C332.627417,24 338,18.6274173 338,12 C338,5.37258267 332.627417,0 326,0 C319.372583,0 314,5.37258267 314,12 C314,18.6274173 319.372583,24 326,24 Z" />
            </g>
          </g>
        </g>
      </svg>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Icons/ChapterDone.js